import { IconCheck, IconCopy } from '@tabler/icons-react';
import { ActionIcon } from '@zorro/design-system/v2/ActionIcon';
import { Tooltip } from '@zorro/design-system/v2/Tooltip';
import { useEffect, useRef, useState } from 'react';

import { CopyToClipboard } from '../CopyToClipboard';

type Props = {
  text: string;
  tooltip?: string;
  size?: number;
};

export function CopyIconButton({ text, tooltip = 'Copy', size = 16 }: Props) {
  const [copied, setCopied] = useState(false);
  const resetTimer = useRef<ReturnType<typeof setTimeout> | undefined>(
    undefined
  );

  useEffect(
    () => () => {
      if (resetTimer.current) {
        clearTimeout(resetTimer.current);
      }
    },
    []
  );

  return (
    <Tooltip label={copied ? 'Copied' : tooltip} withArrow>
      <span>
        <CopyToClipboard
          text={text}
          onCopy={(_, result) => {
            if (result !== 'failed') {
              setCopied(true);
              if (resetTimer.current) {
                clearTimeout(resetTimer.current);
              }
              resetTimer.current = setTimeout(() => setCopied(false), 1500);
            }
          }}
        >
          <ActionIcon size="sm" aria-label={tooltip}>
            {copied ? <IconCheck size={size} /> : <IconCopy size={size} />}
          </ActionIcon>
        </CopyToClipboard>
      </span>
    </Tooltip>
  );
}
